module.exports = __webpack_public_path__ + "img/gameFi.2a50c4e1.png";